export var DEFAULT_SPECIFICATION = [{
  type: 'list',
  value: {
    text: [{
      type: 'text',
      value: 'Для добавления нового коттеджного поселка необходимо:'
    }],
    items: [[{
      type: 'text',
      value: 'Скачать'
    }, {
      type: 'link',
      value: 'анкету',
      href: 'https://static.cdn-cian.ru/frontend/collections-assets/feedback-form/new-village-form.xlsx'
    }], [{
      type: 'text',
      value: 'Заполнить ее'
    }], [{
      type: 'text',
      value: 'Загрузить файлом в данную форму'
    }]]
  }
}];